<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="EditWorkLvMoney" :model="formData" :rules="rules" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="类型" prop="PaWorkLvMoney.type">
            <el-select class="input-item" v-model="formData.PaWorkLvMoney.type" :clearable="true" filterable :disabled="true"
              placeholder="类型" :loading="EditWorkLvMoney.type.impl.loading"
              @visible-change="EditWorkLvMoney.type.impl.onVisibleChange"
              @change="onTypeValueChange">
              <el-option v-for="item in EditWorkLvMoney.type.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" >
          <el-form-item label="名称" prop="PaWorkLvMoney.name">
            <el-input class="input-item" v-model="formData.PaWorkLvMoney.name"
              :clearable="true" placeholder="名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showlvMin">
          <el-form-item :label="labellvMin" prop="PaWorkLvMoney.lvMin">
            <el-input-number class="input-item" v-model="formData.PaWorkLvMoney.lvMin" :clearable="true" :placeholder="labellvMin" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showlvMax">
          <el-form-item :label="labellvMax" prop="PaWorkLvMoney.lvMax">
            <el-input-number class="input-item" v-model="formData.PaWorkLvMoney.lvMax" :clearable="true" :placeholder="labellvMax" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showmoney">
          <el-form-item :label="labelmoney" prop="PaWorkLvMoney.money">
            <el-input-number class="input-item" v-model="formData.PaWorkLvMoney.money" :clearable="true" :placeholder="labelmoney" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showLvD">
          <el-form-item :label="labelLvD" prop="PaWorkLvMoney.lvD">
            <el-input-number class="input-item" v-model="formData.PaWorkLvMoney.lvD" :clearable="true" :placeholder="labelLvD" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaWorkLvMoney.type!=='root'">
          <el-form-item label="启用" prop="PaWorkLvMoney.enableFlag">
            <el-radio-group class="input-item" v-model="formData.PaWorkLvMoney.enableFlag" @change="onEnableFlagValueChange">
              <el-radio v-for="item in EditWorkLvMoney.enableFlag.impl.dropdownList" :key="item.id" :label="item.id">
                {{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaWorkLvMoney.type!=='root'">
          <el-form-item label="排序" prop="PaWorkLvMoney.sort">
            <el-input-number class="input-item" v-model="formData.PaWorkLvMoney.sort"
                             :clearable="true"
                             placeholder="排序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="描述" prop="PaWorkLvMoney.detail">
            <el-input class="input-item" v-model="formData.PaWorkLvMoney.detail"
              :clearable="true" placeholder="描述" type="textarea" :autosize="{ minRows: 4}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="PaWorkLvMoney.remark">
            <el-input class="input-item" v-model="formData.PaWorkLvMoney.remark"
              :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" @click="onUpdateClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaWorkLvMoneyController, DictionaryController } from '@/api';

export default {
  name: 'EditWorkLvMoney',
  props: {
    id: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      showlvMin: false,
      showlvMax: false,
      showmoney: false,
      showLvD: false,
      labellvMin: '比例区间最低',
      labellvMax: '比例区间最高',
      labelmoney: '奖励金额',
      formData: {
        PaWorkLvMoney: {
          id: undefined,
          pid: undefined,
          tid: undefined,
          tname: undefined,
          gcode: undefined,
          code: undefined,
          type: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          deptPostId: undefined,
          enableFlag: 'Y',
          sort: 1,
          lvMin: 0,
          lvMax: 0,
          money: 0,
          lvD: 0,
          lvE: 0,
          lvF: 0,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          isDatasourceInit: false
        }
      },
      rules: {
        'PaWorkLvMoney.name': [{required: true, message: '请输入名称', trigger: 'blur'}],
        'PaWorkLvMoney.lvMin': [{required: true, message: '请输入区间最低', trigger: 'blur'}],
        'PaWorkLvMoney.lvMax': [{required: true, message: '请输入区间最高', trigger: 'blur'}],
        'PaWorkLvMoney.money': [{required: true, message: '请输入奖励金额', trigger: 'blur'}]
      },
      EditWorkLvMoney: {
        formFilter: {
        },
        formFilterCopy: {
        },
        type: {
          impl: new DropdownWidget(this.loadTypeDropdownList)
        },
        enableFlag: {
          impl: new DropdownWidget(this.loadEnableFlagDropdownList)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onSubmit (code) {
      this.$emit('submit', code);
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_work_lv_Money_type'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeValueChange (value) {
    },
    /**
     * 启用下拉数据获取函数
     */
    loadEnableFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYN(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 启用选中值改变
     */
    onEnableFlagValueChange (value) {
    },
    /**
     * 更新编辑作品等级分值
     */
    refreshEditWorkLvMoney (reloadData = false) {
      this.loadPaWorkLvMoneyData().then(res => {
        if (!this.EditWorkLvMoney.isInit) {
          // 初始化下拉数据
          this.EditWorkLvMoney.enableFlag.impl.onVisibleChange(true).catch(e => {});
          this.EditWorkLvMoney.type.impl.onVisibleChange(true).catch(e => {});
        }
        this.EditWorkLvMoney.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      this.$refs.EditWorkLvMoney.validate((valid) => {
        if (!valid) return;
        let paWorkLvMoney = this.formData.PaWorkLvMoney;
        if (paWorkLvMoney.type === 'post') {

        }
        let params = {
          paWorkLvMoneyDto: {
            id: this.id,
            pid: this.formData.PaWorkLvMoney.pid,
            tid: this.formData.PaWorkLvMoney.tid,
            tname: this.formData.PaWorkLvMoney.tname,
            gcode: this.formData.PaWorkLvMoney.gcode,
            code: this.formData.PaWorkLvMoney.code,
            type: this.formData.PaWorkLvMoney.type,
            name: this.formData.PaWorkLvMoney.name,
            detail: this.formData.PaWorkLvMoney.detail,
            remark: this.formData.PaWorkLvMoney.remark,
            deptPostId: this.formData.PaWorkLvMoney.deptPostId,
            lvMin: this.formData.PaWorkLvMoney.lvMin,
            lvMax: this.formData.PaWorkLvMoney.lvMax,
            money: this.formData.PaWorkLvMoney.money,
            lvD: this.formData.PaWorkLvMoney.lvD,
            lvE: this.formData.PaWorkLvMoney.lvE,
            lvF: this.formData.PaWorkLvMoney.lvF,
            sort: this.formData.PaWorkLvMoney.sort,
            enableFlag: this.formData.PaWorkLvMoney.enableFlag
          }
        };

        this.$confirm('是否保存修改?').then(res => {
          PaWorkLvMoneyController.update(this, params).then(res => {
            this.$message.success('保存成功');
            this.refreshEditWorkLvMoney();
            this.onSubmit(true);
          }).catch(e => {});
        }).catch(e => {});
      });
    },
    onResume () {
      this.refreshEditWorkLvMoney(true);
    },
    /**
     * 获取作品级别分值详细信息
     */
    loadPaWorkLvMoneyData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaWorkLvMoney.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          PaWorkLvMoneyController.view(this, params).then(res => {
            let PaWorkLvMoney = {...res.data, isDatasourceInit: true};
            if (PaWorkLvMoney.typeDictMap && this.EditWorkLvMoney.type.impl.dirty) {
              this.EditWorkLvMoney.type.impl.dropdownList = [PaWorkLvMoney.typeDictMap];
            }
            this.EditWorkLvMoney.enableFlag.impl.onVisibleChange(true).catch(e => {});
            // let x = PaWorkLvMoney.type === 'type' ? '(分)' : '(%)';
            // this.labellvMin = this.labellvMin.replace('(分)', '').replace('(%)', '') + x;
            // this.labellvMax = this.labellvMax.replace('(分)', '').replace('(%)', '') + x;
            // this.labelmoney = this.labelmoney.replace('(分)', '').replace('(%)', '') + x;
            // this.labelLvD = this.labelLvD.replace('(分)', '').replace('(%)', '') + x;
            this.showlvMin = this.showlvMax = this.showmoney = this.showLvD = false;
            if (PaWorkLvMoney.type === 'type') {
              // this.showlvMin = this.showlvMax = this.showmoney = this.showLvD = true;
            } else if (PaWorkLvMoney.type === 'post') {
              params.id = PaWorkLvMoney.pid;
              PaWorkLvMoneyController.view(this, params).then(pres => {
                // let parentItem = {...pres.data};
                this.showlvMin = true;
                this.showlvMax = true;
                this.showmoney = true;
                this.showLvD = false;
              });
            }
            this.formData.PaWorkLvMoney = PaWorkLvMoney;
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaWorkLvMoney: {
          id: undefined,
          pid: undefined,
          tid: undefined,
          tname: undefined,
          gcode: undefined,
          code: undefined,
          type: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          deptPostId: undefined,
          enableFlag: undefined,
          sort: undefined,
          lvMin: undefined,
          lvMax: undefined,
          money: undefined,
          lvD: undefined,
          lvE: undefined,
          lvF: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshEditWorkLvMoney();
    }
  },
  computed: {
    // 初始化组件数据所需输入参数
    initPaWorkLvMoneyParamChange () {
      return {
        id: this.id
      }
    },
    // 监听输入参数变化，用于数据变化后重新获取数据，如果存在多个数据组件或者数据组件使用不同的输入参数的优化，请拆分这里的代码
    formInputParamChange () {
      return {
        id: this.id
      }
    }
  },
  watch: {
    // 初始化组件数据所需输入参数，如果有多个初始化数据源需要优化，请修改这里的代码，只重置和更新相应的数据源数据
    initPaWorkLvMoneyParamChange: {
      handler (newValue) {
        this.resetFormData();
        this.refreshEditWorkLvMoney();
      },
      immediate: true
    },
    formInputParamChange: {
      handler (newValue) {
      },
      immediate: true
    }
  }
}
</script>
